import { safeGetJSON, safeRemoveItem, safeSetJSON } from '@/utils/safeStorage';

export const DISMISSAL_KEY = 'truevined_update_dismissal';

const DISMISSAL_MS = 24 * 60 * 60 * 1000;

export function getDismissalInfo(): { until: number } | null {
  const data = safeGetJSON<{ until?: unknown }>(DISMISSAL_KEY);
  if (!data) return null;
  if (typeof data.until === 'number' && data.until > Date.now()) return { until: data.until };

  safeRemoveItem(DISMISSAL_KEY);
  return null;
}

export function setDismissal(): void {
  safeSetJSON(DISMISSAL_KEY, { until: Date.now() + DISMISSAL_MS });
}

export function clearDismissal(): void {
  safeRemoveItem(DISMISSAL_KEY);
}
